/* @flow strict */

import * as React from 'react';
import moment from 'moment';
import DateTimePicker from '/client/src/components/dateTimePicker';

type PropsType = {
  start: string,
  end: string,
  startCb: () => void,
  endCb: () => void
};

const RangeCalendar = (props: PropsType): React.Element<typeof React.Fragment> => {
  const [start, setStart] = React.useState(
    props.start ? props.start : moment().format()
  );
  const [end, setEnd] = React.useState(
    props.end ? props.end : moment().format()
  );

  return (
    <>
      <div className="form-group">
        <div className="input-group date date-start">
          <span
            className="input-group-addon"
            style={{
              borderBottomLeftRadius: '50px',
              borderTopLeftRadius: '50px'
            }}
          >
            <span className="icon icon-calendar" />
          </span>
          <DateTimePicker
            className="range-begin-date"
            date={start}
            noIcon
            dateFormat="MM/dd/yyyy"
            showTimeSelect={false}
            cb={(date: string) => {
              setStart(date);
              props.startCb(moment(date));
            }}
          />
        </div>
      </div>

      <div className="h-line" />

      <div className="form-group">
        <div className="input-group date date-end">
          <DateTimePicker
            className="range-end-date"
            date={end}
            noIcon
            dateFormat="MM/dd/yyyy"
            showTimeSelect={false}
            cb={(date: string) => {
              setEnd(date);
              props.endCb(moment(date));
            }}
          />
          <span className="input-group-addon">
            <span className="icon icon-calendar" />
          </span>
        </div>
      </div>
    </>
  );
};

export default RangeCalendar;
